(function ($, Drupal, drupalSettings) {
    'use strict';
    var langCode = drupalSettings.path.currentLanguage;
    var formatDate = function (date) {
        return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, "0")
         + '-' + String(date.getDate()).padStart(2, "0");
    };

    var datetime_range_picker_init = function (element) {
        var startDate = null;
        var endDate = null;

        if (typeof drupalSettings.date_range_picker !== 'undefined') {
            if (typeof drupalSettings.date_range_picker[element.id].start !== 'undefined') {
                startDate = new Date(drupalSettings.date_range_picker[element.id].start + ' 12:00');
            }

            if (typeof drupalSettings.date_range_picker[element.id].end !== 'undefined') {
                endDate = new Date(drupalSettings.date_range_picker[element.id].end + ' 12:00');
            }
        }

        var picker = new Litepicker({
            element: element,
            plugins: ['keyboardnav'],
            elementEnd: null,
            firstDay: 1,
            format: "YYYY.MM.DD",
            lang: langCode,
            numberOfMonths: 1,
            numberOfColumns: 1,
            startDate: startDate,
            endDate: endDate,
            zIndex: 9,
            minDate: null,
            maxDate: null,
            minDays: null,
            maxDays: null,
            selectForward: !1,
            selectBackward: !1,
            splitView: !1,
            inlineMode: !1,
            singleMode: !1,
            autoApply: !0,
            allowRepick: true,
            showWeekNumbers: !1,
            showTooltip: !0,
            hotelMode: !1,
            disableWeekends: !0,
            scrollToDate: !0,
            mobileFriendly: !0,
            lockDaysFormat: "YYYY-MM-DD",
            lockDays: [],
            bookedDaysFormat: "YYYY-MM-DD",
            bookedDays: [],
            dropdowns: {
                minYear: 1990,
                maxYear: null,
                months: !1,
                years: !1
            },
            buttonText: {
                apply: "Apply",
                cancel: "Cancel",
                previousMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12"><path d="M4.5 1.5L10.5 10.5 -1.5 10.5z" transform="translate(-410 -368) translate(388 338) translate(16 16) translate(6 14) matrix(0 1 1 0 -1.5 1.5)" fill-rule="evenodd" fill="#221F1F" /></svg>',
                nextMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12"><path d="M4.5 1.5L10.5 10.5 -1.5 10.5z" transform="translate(-669 -368) translate(388 338) translate(16 16) translate(265 14) rotate(90 4.5 6)" fill-rule="nonzero" fill="#221F1F" /></svg>'
            },
            setup: (picker) => {
                var date = '';
                var start_date = '';
                var end_date = '';
                picker.on('selected', (date1, date2) => {
                    date = picker.getDate();
                    start_date = picker.getStartDate();
                    end_date = picker.getEndDate();
                    $('.form-item-field-event-date-min [id^=edit-field-event-date-min]').val(sanitizePicker(Drupal.checkPlain(start_date.format('YYYY-MM-DD'))));
                    $('.form-item-field-event-date-max [id^=edit-field-event-date-max]').val(sanitizePicker(Drupal.checkPlain(end_date.format('YYYY-MM-DD'))));
                    start_date = sanitizePicker($('.form-item-field-event-date-min [id^=edit-field-event-date-min]').val());
                    end_date = sanitizePicker($('.form-item-field-event-date-max [id^=edit-field-event-date-max]').val());
                    $('#date_range').val($(this).val());
                    var calendar_selected_value = calendarPlaceholderDateFormat(sanitizePicker(langCode), start_date, end_date);
                    $('.litepicker-input').addClass('clicked');
                    $('.calendar-date-value-placeholder').html(calendar_selected_value);
                });
                picker.on('render', (ui) => {
                    start_date = sanitizePicker($('.form-item-field-event-date-min [id^=edit-field-event-date-min]').val());
                    end_date = sanitizePicker($('.form-item-field-event-date-max [id^=edit-field-event-date-max]').val());
                    var calendar_placeholder_value = calendarPlaceholderDateFormat(langCode, start_date, end_date);
                    var btn_label_clear_calendar = Drupal.t('Clear all');
                    var btn_obj_clear_calendar = $('<div class="wrapper-calendar-clear-btn"><input type="button"  tabindex="2" onClick="calendarClearButton(); return false;" id="calendar-clear-btn" value="' + btn_label_clear_calendar + '" /></div>');
                    btn_obj_clear_calendar.insertAfter(".container__days");
                    if (start_date && end_date) {
                        picker.setDateRange(start_date, end_date, true);
                        $('.calendar-date-value-placeholder').html(calendar_placeholder_value);
                        $('.litepicker-input').addClass('clicked');
                    }
                });
                picker.on('hide', (el) => {
                    start_date = sanitizePicker($('.form-item-field-event-date-min [id^=edit-field-event-date-min]').val());
                    end_date = sanitizePicker($('.form-item-field-event-date-max [id^=edit-field-event-date-max]').val());
                    if (start_date && end_date) {
                        picker.setDateRange(start_date, end_date, true);
                        $('.litepicker-input').addClass('clicked');
                    } else {
                        $('.litepicker-input').removeClass('clicked');
                    }
                    if (drupalSettings.start_date != '' && drupalSettings.end_date != '') {
                        var unSanitizedVal = $(element).closest('.arctic-daterange').attr('attr');
                        var closest_form = sanitizePicker(unSanitizedVal);
                        $("#" + closest_form).trigger("submit");
                    }
                });
              },
            tooltipText: { one: "day", other: "days" },
            onShow: function () {
                console.log("onShow callback");
            },
            onHide: function () {
                console.log("onHide callback");
            },
            onSelected: function (e, t) {
              console.log("onSelect ");
            },
            onError: function (e) {
                console.log("onError callback", e);
            },
            onChangeMonth: function (e, t) {
                console.log("onChangeMonth callback", e, t);
            },
            onChangeYear: function (e) {
                console.log("onChangeYear callback", e);
            }
        });

    };

    Drupal.behaviors.datetime_range_picker = {

        attach: function (context) {
        var $dateRangeWidgets = $(context).find('.arctic-daterange');
        $dateRangeWidgets.each(function () {
          var $dateRangeWidget = $(this);
          $dateRangeWidget.find('.litepicker-input').each(function () {
            datetime_range_picker_init(this);
          });
        });
        }
    }
    
}(jQuery, Drupal, drupalSettings));

//reset calendar filter
function calendarClearButton() {
    var url = location.href;
    url = removeURLParameter("field_event_date", url);
    url = removeURLParameter("field_event_date", url);
    url = url.replace(/-[0-9][0-9]/g, "");
    window.location.href = url;
}

// Calendar date format (MMM, DD-DD, YYYY)
function calendarPlaceholderDateFormat(locale, cal_start_date, cal_end_date) {
    var cal_start_date = new Date(cal_start_date);
    var cal_end_date = new Date(cal_end_date);
    var calendar_placeholder = '';
    var cal_start_date_month = cal_start_date.toLocaleString(locale, { month: 'short' });
    var cal_end_date_month = cal_end_date.toLocaleString(locale, { month: 'short' });
    var cal_start_date_day = cal_start_date.toLocaleString(locale, { day: 'numeric' });
    var cal_end_date_day = cal_end_date.toLocaleString(locale, { day: 'numeric' });
    var cal_start_date_year = cal_start_date.toLocaleString(locale, { year: 'numeric' });
    var cal_end_date_year = cal_end_date.toLocaleString(locale, { year: 'numeric' });
    if ((cal_start_date_month == cal_end_date_month) && (cal_start_date_year == cal_end_date_year)) {
    //Jan 1 - Jan 2, 2021
      calendar_placeholder = cal_start_date_month + ' ' + cal_start_date_day + ' - ' + cal_end_date_month + ' ' + cal_end_date_day + ', ' + cal_end_date_year;
    } else if ((cal_start_date_month == cal_end_date_month) && (cal_start_date_year != cal_end_date_year)) {
    //nov 1, 2020 - nov 3, 2021
      calendar_placeholder = cal_start_date_month + ' ' + cal_start_date_day + ', ' + cal_start_date_year + ' - ' + cal_end_date_month + ' ' + cal_end_date_day + ', ' + cal_end_date_year;
    } else if ((cal_start_date_month != cal_end_date_month) && (cal_start_date_year == cal_end_date_year)) {
    //Oct 6 - Nov 1, 2020
      calendar_placeholder = cal_start_date_month + ' ' + cal_start_date_day + ' - ' + cal_end_date_month + ' ' + cal_end_date_day + ', ' + cal_end_date_year;
    } else if ((cal_start_date_month != cal_end_date_month) && (cal_start_date_year != cal_end_date_year)) {
    //Nov 5, 2020 - May 8, 2021
      calendar_placeholder = cal_start_date_month + ' ' + cal_start_date_day + ', ' + cal_start_date_year + ' - ' + cal_end_date_month + ' ' + cal_end_date_day + ', ' + cal_end_date_year;
    }
    return calendar_placeholder;
}

function sanitizePicker(html) {
    var temp = document.createElement('div');
    temp.innerText = html;
    return temp.textContent
  }
  